import React from "react";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import logo from "./../../assets/Dtac.png";
import userImg from "./../../assets/user.png";
import { Logout } from "../../utils/sessions";
import * as alertDialog from "../../utils/alert";

//Material
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Zoom from "@material-ui/core/Zoom";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";
import manualImg from "../../assets/manual.png";
import faqImg from "../../assets/faq.png";
import Link from "@material-ui/core/Link";
import Collapse from "@material-ui/core/Collapse";

const drawerWidth = "15%";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbarDtac: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  grow: {
    flexGrow: 1,
  },
  logo: {},
  name: {},
  icon: {
    color: "#19aaf9",
    marginLeft: theme.spacing(1),
  },
  divider: {
    height: 28,
    margin: 4,
  },
  menuButton: {
    marginRight: 5,
    display: (props) => (props.open ? "none" : "block"),
  },
  appBar: {
    backgroundColor: "#FFF",
    color: "black",
    width: (props) => (props.open ? `calc(100% - ${drawerWidth})` : "100%"),
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: (props) => (props.open ? drawerWidth : 0),
  },
  appBarShift: {
    marginLeft: "4%",
    width: `calc(100% - 4%)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    backgroundColor: "#D8D8D8",
    position: "fixed",
    top: "0px",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    top: "0px",
  },
  drawerClose: {
    width: "4%",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    top: "0px",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  fullContent: {
    border: "5px solid #D8D8D8",
    marginTop: "65px",
    width: `calc(100% - ${drawerWidth})`,
    marginLeft: drawerWidth,
    height: "100%",
    paddingBottom: "20px",
  },
  miniContent: {
    border: "5px solid #D8D8D8",
    marginTop: "65px",
    width: "96%",
    marginLeft: "4%",
    height: "100%",
    paddingBottom: "20px",
  },
}));

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};
export const MuiAppbar2 = ({
  children,
  user,
  ScreenName,
  ScreenList = [],
  ...props
}) => {
  const theme = useTheme();

  const drawerOpenBar = "drawerOpenBar";
  const drawerOpenKey = "drawerOpen";
  const drawerSelectnKey = "selectOpen";
  const [open, setOpen] = React.useState(
    localStorage.getItem(drawerOpenBar) ?? false
  );
  const [openBar, setOpenBar] = React.useState(false);
  const [openExpand, setOpenExpand] = React.useState([]);
  const [selectedIndexPage, setSelectedIndexPage] = React.useState(
    localStorage.getItem(drawerSelectnKey) ?? 0
  );
  const history = useHistory();
  const handleDrawerOpen = () => {
    setOpen(true);
    localStorage.setItem(drawerOpenBar, JSON.stringify(true));
  };
  const classes = useStyles({ open });
  const handleDrawerClose = () => {
    setOpen(false);
    localStorage.setItem(drawerOpenBar, JSON.stringify(false));
  };
  React.useEffect(() => {
    setOpen(JSON.parse(localStorage.getItem(drawerOpenBar)));
  }, [open]);
  React.useEffect(() => {
    setSelectedIndexPage(localStorage.getItem(drawerSelectnKey));
  }, [selectedIndexPage]);

  // React.useEffect(() => {
  //     console.log(localStorage.getItem(drawerOpenKey));
  //     setOpenExpand(localStorage.getItem(drawerOpenKey));
  //   }, [openExpand]);

  const handleClick = (id) => {
    // setOpenExpand(prevState => ({ ...prevState, [id]: !prevState[id] }));
    // console.log(openExpand);
    // localStorage.setItem(drawerOpenKey, openExpand);
  };

  const handleListItemClick = (event, index) => {
    setSelectedIndexPage(index);
    localStorage.setItem(drawerSelectnKey, index);
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: !open,
        })}
      >
        <Toolbar className={classes.toolbarDtac}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Link
            component="button"
            variant="body2"
            onClick={() => history.push("/")}
          >
            <img src={logo} height="50px" width="305px" alt="" title="Home" />
          </Link>
          {/* <h5 style={{ margin: 'auto', fontWeight: 'bold' }}>BI Web Portal</h5> */}
          <div className={classes.grow} />

          <Typography style={{ margin: "auto", fontWeight: "bold" }}>
            {user}
          </Typography>
          {/* <PersonIcon fontSize='inherit' className={classes.icon} onClick={async () => {
                        let res = await alertDialog.ConfirmCommon("Do you want to Logout ?", "Yes", "No")
                        if (!res) return;
                        Logout();
                    }} /> */}
          <Link
            component="button"
            variant="body2"
            onClick={async () => {
              let res = await alertDialog.ConfirmCommon(
                "Do you want to Logout ?",
                "Yes",
                "No"
              );
              if (!res) return;
              Logout();
            }}
          >
            <img
              src={userImg}
              style={{ marginLeft: "15px", marginRight: "5px" }}
              alt="Log out"
              title="Log out"
              width="35"
              height="35"
            />
          </Link>
          <Divider className={classes.divider} orientation="vertical" />
          <Link
            component="button"
            variant="body2"
            onClick={() => history.push("/Faq")}
          >
            <img
              src={faqImg}
              style={{ marginLeft: "1px" }}
              alt="FAQ"
              title="FAQ"
              width="40"
              height="40"
            />
          </Link>
          <Divider className={classes.divider} orientation="vertical" />
          <Link
            component="button"
            variant="body2"
            onClick={() => history.push("/Manual")}
          >
            <img
              src={manualImg}
              style={{ marginLeft: "1px" }}
              alt="Manual"
              width="40"
              height="40"
              title="Manual"
            />
          </Link>
          <Divider className={classes.divider} orientation="vertical" />
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          {ScreenList?.map((grp, i) => (
            <div key={grp.Group}>
              {open ? (
                <ListItem
                  key={grp.Group}
                  style={{ backgroundColor: "#D8D8D8" }}

                  //onClick={() => handleClick(i)}
                >
                  <ListItemText
                    disableTypography
                    primary={
                      <Typography
                        type="body2"
                        style={{ fontWeight: "bold", fontSize: "20px" }}
                      >
                        {grp.Group}
                      </Typography>
                    }
                  />
                  {/* <ListItemIcon>
                                    <InboxIcon />
                                    {i}
                                </ListItemIcon> */}
                  {/* <ListItemText primary={grp.Group} /> */}
                  {/* {openExpand[i] ? <ExpandLess /> : <ExpandMore />} */}
                  {/* <ExpandLess /> */}
                </ListItem>
              ) : (
                ""
              )}
              {open ? <Divider /> : ""}
              <Collapse
                key={i}
                //in={openExpand[i]}
                in={true}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding key={i}>
                  {/* {console.log(selectedIndexPage)} */}
                  {grp?.Modules.map((el, index) => (
                    <ListItem
                      button
                      key={el.ID}
                      selected={selectedIndexPage === el.ID}
                      onClick={(event) => handleListItemClick(event, el.ID)}
                      component={RouterLink}
                      to={el.path || "/"}
                      style={{ justifyContent: "center" }}
                      className={classes.nested}
                    >
                      <ListItemIcon style={{ minWidth: "30px" }}>
                        {/* <StarBorder /> */}
                        <img
                          src={el.IMG_ICON}
                          style={{ margin: "auto" }}
                          alt=""
                          width="30"
                          height="30"
                          title={el.MODULE_NAME || ""}
                        />
                      </ListItemIcon>

                      {open ? (
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography
                              type="body2"
                              style={{
                                marginLeft: "10px",
                                fontWeight: "bold",
                                fontSize: "15px",
                              }}
                            >
                              {el.MODULE_NAME || ""}
                            </Typography>
                          }
                        />
                      ) : (
                        ""
                      )}
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </div>
          ))}
        </List>
        <Divider />
      </Drawer>
      <main
        className={clsx(classes.fullContent, {
          [classes.fullContent]: open,
          [classes.miniContent]: !open,
        })}
      >
        <Toolbar />

        {children}

        {/* <section name="goTop">
                    <ScrollTop {...props}>
                        <Fab color="secondary" size="small" aria-label="scroll back to top">
                            <KeyboardArrowUpIcon />
                        </Fab>
                    </ScrollTop>
                </section> */}
      </main>
    </div>
  );
};
MuiAppbar2.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  user: PropTypes.string,
};
export default MuiAppbar2;
